export default __webpack_public_path__ + "static/media/logo_dark_mode.c3010f19.svg";